var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReset1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.1974C3.20577 12.1594 2 10.2201 2 7.99999C2 4.68628 4.68629 1.99999 8 1.99999C11.3137 1.99999 14 4.68628 14 7.99999C14 10.3749 12.6202 12.4285 10.6163 13.4012L11.053 14.3008C13.3883 13.1673 15 10.7723 15 7.99999C15 4.13399 11.866 0.999987 8 0.999987C4.13401 0.999987 1 4.13399 1 7.99999C1 10.5471 2.36045 12.7756 4.39261 14H2V15H5.5C5.77614 15 6 14.7761 6 14.5L6 11H5L5 13.1974Z",
    fill: "#141414"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset1);
export default __webpack_public_path__ + "static/media/reset 1.2fcb98c5.svg";
export { ForwardRef as ReactComponent };